<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('transaction')">
            <app-default-button class="mr-1"
                :title="$fieldTitle('add', 'transaction', true)"
                v-if="$can('create_finance_transactions')"
                @click="openModal()"
            />
            <!-- <app-default-button class="btn-success mr-2"
                :title="$t('account')"
                @click="redirectTo('/finance/accounts')"
            />
            <app-default-button class="btn-success"
                :title="$t('category')"
                @click="redirectTo('/finance/categories')"
            /> -->
            <app-default-button class="btn-success mr-1"
                :title="$t('tag')"
                @click="redirectTo('/finance/tags')"
            />
            <app-default-button class="btn-success"
                :title="$t('report')"
                @click="redirectTo('/finance/transaction-report')"
            />
        </app-page-top-section>

        <app-table
            id="finance-transaction-table"
            :options="options"
            @action="triggerActions"
        />

        <app-finance-transaction-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('finance-transaction-table')"
            @cancelled="cancelled"
        />

        <app-finance-transaction-confirm
            v-if="isConfirmModalActive"
            v-model="isConfirmModalActive"
            :transaction-id="transactionId"
        />

        <app-finance-transaction-detail
            v-if="isDetailModalActive"
            v-model="isDetailModalActive"
            :transaction-id="transactionId"
        />

        <app-finance-advance-payment-create
            v-if="isAdvancePaymentModalActive"
            v-model="isAdvancePaymentModalActive"
            :transaction-id="transactionId"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import FinanceTransactionMixin from "../../Mixins/FinanceTransactionMixin";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";

export default {
    name  : "FinanceTransaction",
    mixins: [HelperMixin, FinanceTransactionMixin],
    data() {
        return {
            isModalTypeActive: false,
            isModalActive    : false,
            isConfirmModalActive: false,
            isDetailModalActive: false,
            selectedUrl      : '',
            transactionId    : null,
            isAdvancePaymentModalActive: false,
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.name === 'view') {
                this.transactionId = row.id;
                this.isDetailModalActive = true;
                return;
            }

            if (!row.editable) {
                this.$toastr.e(this.$t('this_record_can_no_longer_be_edited'));
                return;
            }

            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/finance-transactions/${row.id}`;
                this.isModalActive = true;
            } else if (action.name === 'advance-payment') {
                this.transactionId = row.id;
                this.isAdvancePaymentModalActive = true;
            } else if (action.name === 'confirm') {
                this.transactionId = row.id;
                this.isConfirmModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>

<style scoped>
::v-deep .btn-success {
    color: #ffffff !important;
    background-color: #46c35f !important;
    border-color: #46c35f !important;
}

::v-deep .reorder-handle {
    width: 40px;
}

::v-deep .reorder-handle .drag-icon {
    cursor: grab;
    user-select: none;
}

::v-deep .reorder-handle .drag-icon:active {
    cursor: grabbing;
}
</style>
